import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';

const ProductsIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/products'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'products_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'products_index',
          meta: {
            permissions: [...ROLES],
          },
          component: ProductsIndex,
        },
      ],
    },
  ],
};
